import {PatientDetailsPage} from '@/modules/patients/components/patient-details/patient-details-page'
import {DialogBody, DialogHeader} from '@cypro/ui/components'
import {useTranslate} from '@tolgee/react'
import {useGetPatient} from '../../api'
import {getPatientFullName} from '../../functions'

export function PatientRecordWindow({patientId}: {patientId: string}) {
  const {t} = useTranslate('common')
  const [patient] = useGetPatient(patientId)

  return (
    <>
      <DialogHeader>
        {t('patient_therapy_record')} - {getPatientFullName(patient)}
      </DialogHeader>

      <DialogBody display="flex" flex="1" minHeight="0" padding="0" overflow="hidden">
        <PatientDetailsPage patientId={patientId} initialTab="therapy" />
      </DialogBody>
    </>
  )
}
